<template>
  <!-- <transition name="modal" > -->
  <div id="modal-template">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <button class="modal-close-button" @click="$emit('close') & closeGA4Click()">X</button>
          <!-- <div class="modal-header">
            <slot name="header">
              default header
            </slot>
          </div>-->

          <div :class="wichModal==='register' ? 'modal-body-large' : 'modal-body-body'">
            <slot name="body">
              <Terms v-if="wichModal === 'terms'" name="tecate00" />
              <Politics v-if="wichModal === 'politics'" name="tecate00" />
              <Cookies v-if="wichModal === 'cookies'" name="tecate00" />
              <Register v-if="wichModal==='register'" name="register" @close="$emit('close')" @openTerms="$emit('openTerms', true)" @openPrivacy="$emit('openPrivacy', true)" ></Register>
            </slot>
          </div>

          <!-- <div class="modal-footer">
            <slot name="footer">
              default footer
              <button class="modal-default-button" @click="$emit('close')">
                OK
              </button>
            </slot>
          </div>-->
        </div>
      </div>
    </div>
  </div>
  <!-- </transition> -->
</template>

<script>
import Terms from "@/components/Terms";
import Politics from "@/components/Politics";
import Cookies from "@/components/Cookies";
import Register from "@/components/Register";
import tagFunctions from '@/utils/tagFunctions.js'
export default {
  name: "Modal",
  components: {
    Terms,
    Politics,
    Cookies,
    Register
  },
  props: {
    wichModal: {
      type: String,
      default: "none"
    }
  },
  methods: {
    showModal(modal) {
      this.wichModal = modal;
      this.closeGA4Click();
    },
    closeGA4Click() {
      const valorModal = this.wichModal;
      if (valorModal == 'terms') {
        tagFunctions.user_interactionPush('click', 'cerrar', 'popup terminos y condiciones')
      } else if (valorModal == 'politics') {
        tagFunctions.user_interactionPush('click', 'cerrar', 'popup politica de privacidad')
      } else if (valorModal == 'cookies') {
        tagFunctions.user_interactionPush('click', 'cerrar', 'popup politica de cookies')
      } else if (valorModal == 'register') {
        tagFunctions.user_interactionPush('click', 'cerrar', 'popup registro')
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/modal.scss";
</style>
